import { Injectable } from '@angular/core';
import { I18nService } from 'src/app/service/i18n.service';
import { EnvironmentConfig } from '../../environments/environmentConfig';
import { Router, ActivatedRoute } from '@angular/router';
import { UrlService } from './url.service';
import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/service/util.service';

@Injectable({
  providedIn: 'root'
})
export class AdobeAnalyticsDigitalDataService {

  private loadOk: boolean = false;
  currentLang: string;
  trackCustom: string = '';

  previousUrl: string = '';
  previousUrlSwitch: string = '';
  appVersion: any;
  lastBuildDate: any;
  appEnvironment: string;
  pageName: string;
  currentUrl: any;
  prefillMethod: string = '';
  formPrefill: boolean;
  formQualify: boolean;
  formView: boolean;
  formSubmit: boolean;
  preQualObj: any;
  formUniqueId: any;
  flowType: any;
  pageRouteSwitch: { url: string; pageName: string; hierarchy: string[]; }[];
  hierarchy: string;
  userId: string = '';
  formId: string = '';
  // pageNameSwitch: string = 'about-yourself';
  currentUrlSwitch: string = '';
  formSubmitSwitch: boolean;
  formUniqueIdSwitch: any;



  constructor(
    private i18nService: I18nService,
    private envConfObj: EnvironmentConfig,
    public router: Router,
    private _activatedRoute: ActivatedRoute,
    private urlService: UrlService,
    private util: UtilService
  ) {
    this.currentLang = sessionStorage.getItem("currLang");
    if (!this.currentUrl) this.currentUrl = router.url;
    this.previousUrl = router.url;
  }

  load(pageRoute = null) {
    if (sessionStorage.getItem("prevPageUrl") != null) {
      this.previousUrlSwitch = sessionStorage.getItem("prevPageUrl");
    }
    this.currentUrlSwitch = document.location.href;
    sessionStorage.setItem("prevPageUrl", this.currentUrlSwitch);
    this.urlService.previousUrl$
      .subscribe((previousUrl: string) => {
        this.previousUrl = previousUrl;
      });
    if (!this.previousUrl) {
      this.previousUrl = ''
    }
    this.appEnvironment = (this.envConfObj.environment == 'prod') ? "production" : "development";
    this.appVersion = environment.appVersion;
    this.lastBuildDate = environment.lastBuildDate;
    let curLng = sessionStorage.getItem("currLang");
    if (pageRoute == '/en/home' || pageRoute == '/en/home?flow=switch') {
      curLng = 'en';
    }
    if (pageRoute == '/fr/home' || pageRoute == '/fr/home?flow=switch') {
      curLng = 'fr';
    }
    this.preQualObj = this.util.getSessionStorage()
    let authenticated = (sessionStorage.getItem("isAuthenticated") == 'yes') ? "authenticated" : "not-authenticated";
    pageRoute = pageRoute.replace("/en/", "");
    pageRoute = pageRoute.replace("/fr/", "");
    this.currentUrl = pageRoute;

    if (pageRoute.includes("?flow=switch")) {
      this.flowType = 'S'
    }
    else {
      this.flowType = 'P'
    }
    //hierarchy

    if (this.flowType == 'S') {
      pageRoute = pageRoute.replace('?flow=switch', '');
      if (this.preQualObj != null) {
        if (this.preQualObj.is_coapplicant_applied != null) {
          if (this.preQualObj.is_coapplicant_applied == 'Y') {
            this.hierarchy = 'co-application';
            // if (this.preQualObj.is_existing_bankcustomers != null && this.preQualObj.are_both_applicants_CIBC_customer != null) {
            //   if (this.preQualObj.is_existing_bankcustomers == 'Y' && this.preQualObj.are_both_applicants_CIBC_customer == 'N') {
            //     this.pageNameSwitch = "about-co-applicant";
            //   }
            // }
          }
          else {
            this.hierarchy = 'application';
          }
        }
        if (this.preQualObj.users && this.preQualObj.users.length > 0) {
          this.userId = this.preQualObj.users[0].customer_id;
        }
        else {
          this.userId = '';
        }
        if (sessionStorage.getItem("transactionid")) {
          this.formId = atob(sessionStorage.getItem("transactionid"))
        }

        if (this.pageName == "pre-confirmation") {
          this.formSubmitSwitch = true;
        }
        else {
          this.formSubmitSwitch = null;
        }
        if (this.pageName == "pre-confirmation" || this.pageName == "confirmation") {
          this.formUniqueIdSwitch = this.preQualObj.preQualify_mortgage_reference_number
        }
        else {
          this.formUniqueIdSwitch = null;
        }
      }
    }
    if (pageRoute != null) {
      this.pageName = this._getPageName(pageRoute);
    } else {
      pageRoute = this.router.url
      this.pageName = this._getPageName(pageRoute);
    }

    if (this.pageName == "before-begin") {
      this.formQualify = true
    } else {
      this.formQualify = null
    }

    if (this.pageName == "confirmation") {
      this.formSubmit = true
      this.formUniqueId = this.preQualObj.preQualify_mortgage_reference_number
    } else if (this.pageName == "popup") {
      this.formSubmit = true
      this.formUniqueId = this.preQualObj.preQualify_mortgage_reference_number
    }
    else {
      this.formSubmit = null
      this.formUniqueId = null
    }

    this.prefillMethod = null
    this.formPrefill = null
    if (pageRoute == "personal-information") {
      this.prefillMethod = "bank-card"
      this.formPrefill = true
    }

    if (this.flowType == 'P') {
      if (pageRoute == "personal-information-about-yourself") {
        this.formView = true
      } else {
        this.formView = null
      }
    }
    else if (this.flowType == 'S') {
      if (pageRoute == 'co-applicant-selection') {
        this.formView = true
      } else {
        this.formView = null
      }
    }

    let hierarchy = (this.flowType == 'P') ? this._getHierarchy(pageRoute) : this._getHierarchySwitch(pageRoute)
    if (this.flowType == 'P') {
      var digitalData = {
        "events": {
          "pageView": true,
          "formView": this.formView,
          "formQualify": this.formQualify,
          "formStep": true,
          "formPrefill": this.formPrefill,
          "formSubmit": this.formSubmit,
          "error": false,
        },
        "site": {
          "brand": "cibc",
          "name": "mortgage-prequalification",
          "type": "responsive",
          "environment": this.appEnvironment,
          "appVersion": this.appVersion,
          "lastBuildDate": this.lastBuildDate
        },
        "page": {
          "name": this.pageName,
          "url": pageRoute,
          "referrer": this.previousUrl,
          "hierarchy": hierarchy,
          "language": curLng,
          "accessibility": true
        },
        "user": {
          "authState": authenticated,
          "type": '',
          "ID": ''
        },
        "form": {
          "name": "mortgage-prequalification",
          "stepName": this.pageName,
          "prefillMethod": this.prefillMethod,
          "uniqueID": this.formUniqueId
        },
        "errors": [{
          "code": '',
          "field": '',
          "type": '',
          "subtype": ''
        }
        ]

      };
    }
    else if (this.flowType == 'S') {
      var digitalDataSwitch = {
        "events": {
          "pageView": true,
          "formView": this.formView,
          "formQualify": this.formQualify,
          "formStep": true,
          "formPrefill": this.formPrefill,
          "formSubmit": this.formSubmitSwitch,
          "error": false,
        },
        "site": {
          "brand": "cibc",
          "name": "digital-switch",
          "type": "responsive",
          "environment": this.appEnvironment,
          "appVersion": this.appVersion,
          "lastBuildDate": this.lastBuildDate
        },
        "page": {
          "name": this.pageName,
          "url": document.location.href,
          "referrer": this.previousUrlSwitch,
          "hierarchy": hierarchy,
          "language": curLng,
          "accessibility": true
        },
        "user": {
          "authState": "not-authenticated",
          "type": '',
          "ID": ''
        },
        "form": {
          "name": "digital-switch",
          "stepName": this.pageName,
          "prefillMethod": this.prefillMethod,
          "uniqueID": this.formUniqueIdSwitch
        },
        "errors": [{
          "code": '',
          "field": '',
          "type": '',
          "subtype": ''
        }
        ]

      };
    }
    if (this.flowType == 'P') {
      var digitalDataJson = JSON.stringify(digitalData, null, 2)
    }
    else if (this.flowType == 'S') {
      var digitalDataJson = JSON.stringify(digitalDataSwitch, null, 2)
    }
    return digitalDataJson;

  }



  private _getPageName(routeUrl) {
    let result = routeUrl.replace("/en/", "");
    result = result.replace("/fr/", "");
    if (result == "/") {
      result = "home"
    }


    if (this.flowType == 'P') {
      if (sessionStorage.getItem("co-applicant-flow") == 'yes') {
        var pageRoute = new Map([
          ['home', 'before-begin'],

          ['cibc-customer-selection', 'co-applicant-customer-selection'],
          ['personal-information', 'co-applicant-about-yourself'],
          ['cb-consent', 'co-applicant-consent'], //terms-and-conditions, co-applicant-consent, co-applicant-terms-and-conditions
          ['terms-and-conditions', 'co-applicant-terms-and-conditions'],
          ['income', 'total-income'],
          ['verify-identity', 'co-applicant-verify-identity'], //co-applicant-verify-identity
          ['personal-information-contact', 'co-applicant-contact-info'], ///co-applicant-contact-info
          ['personal-information-preview', 'co-applicant-preview'], ///co-applicant-preview
          ['personal-information-about-yourself', 'co-applicant-about-yourself'], //co-applicant-about-yourself
          ['personal-information-address', 'co-applicant-address-info'], //co-applicant-address-info
          ['summary', 'confirmation'],
          ['request-callback', 'error'],
          ['co-applicant-flow-start', 'co-applicant-flow-start'],
          ['time-to-purchase', 'time-to-purchase'],


        ]);
      } else {
        var pageRoute = new Map([
          ['home', 'before-begin'],
          ['co-applicant-selection', 'co-applicant-selection'], //co-applicant-customer-selection
          ['cibc-customer-selection', 'customer-selection'],
          ['personal-information', 'about-yourself'],
          ['cb-consent', 'consent'], //terms-and-conditions, co-applicant-consent, co-applicant-terms-and-conditions
          ['terms-and-conditions', 'terms-and-conditions'],
          ['income', 'total-income'],
          ['verify-identity', 'verify-identity'], //co-applicant-verify-identity
          ['personal-information-contact', 'contact-info'], ///co-applicant-contact-info
          ['personal-information-preview', 'preview'], ///co-applicant-preview
          ['personal-information-about-yourself', 'about-yourself'], //co-applicant-about-yourself
          ['personal-information-address', 'address-info'], //co-applicant-address-info
          ['summary', 'confirmation'],
          ['request-callback', 'error'],
          ['co-applicant-flow-start', 'co-applicant-flow-start'],
          ['time-to-purchase', 'time-to-purchase'],


        ]);

      }
    }

    else if (this.flowType == 'S') {
      this.pageRouteSwitch = [
        { url: 'home', pageName: 'before-begin', hierarchy: ['application'] },
        { url: 'co-applicant-selection', pageName: 'co-applicant-selection', hierarchy: ['application'] },
        { url: 'cibc-customer-selection', pageName: 'customer-selection', hierarchy: [this.hierarchy] },
        { url: 'co-applicant-flow-start', pageName: 'about-co-applicant', hierarchy: [this.hierarchy, 'personal-info'] },
        { url: 'personal-information', pageName: 'review', hierarchy: [this.hierarchy, 'personal-info'] },
        { url: 'personal-information-about-yourself', pageName: 'about-yourself', hierarchy: [this.hierarchy, 'personal-info'] },
        { url: 'personal-information-address', pageName: 'address-info', hierarchy: [this.hierarchy, 'personal-info'] },
        {
          url: 'personal-information-contact', pageName: 'contact-info', hierarchy: [this.hierarchy, 'personal-info']
        },
        { url: 'personal-information-preview', pageName: 'review', hierarchy: [this.hierarchy, 'personal-info'] },
        { url: 'income', pageName: 'income-details', hierarchy: [this.hierarchy, 'personal-info'] },
        { url: 'cb-consent', pageName: 'credit-bureau-authorization', hierarchy: [this.hierarchy] },
        { url: 'terms-and-conditions', pageName: 'terms-and-conditions', hierarchy: [this.hierarchy] },
        { url: 'mortgage-detail', pageName: 'mortgage-details', hierarchy: [this.hierarchy] },
        { url: 'estimated_value_of_home', pageName: 'property-details', hierarchy: [this.hierarchy, 'mortgage'] },
        { url: 'additonal-mortgage-details', pageName: 'additional-details', hierarchy: [this.hierarchy, 'mortgage'] },
        { url: 'your-online-exclusive-rate-offers', pageName: 'offer-selection', hierarchy: [this.hierarchy, 'mortgage'] },
        { url: 'offer-popup', pageName: 'offer-terms', hierarchy: [this.hierarchy, 'mortgage'] },
        { url: 'summary', pageName: 'pre-confirmation', hierarchy: [this.hierarchy, 'mortgage'] },
        { url: 'confirmation', pageName: 'confirmation', hierarchy: [this.hierarchy, 'mortgage'] },
        { url: 'popup', pageName: 'confirmation-popup', hierarchy: [this.hierarchy, 'mortgage'] },
        { url: 'request-callback', pageName: 'request-a-call', hierarchy: [this.hierarchy] },
      ];
    }
    if (this.flowType == 'P')
      var res = pageRoute.get(result);
    else if (this.flowType == 'S') {
      var res = this.pageRouteSwitch.find(obj => obj.url == result)?.pageName;
    }
    return res

  }


  private _getHierarchy(routeUrl) {
    if (routeUrl.includes("personal-information")) {
      return new Array("apply", "personal-information")
    }

    return new Array("application")
  }
  private _getHierarchySwitch(routeUrl) {
    return (this.pageRouteSwitch.find(obj => obj.url == routeUrl)?.hierarchy)
  }

}



